import type { IconPrimitives, IconProps } from './types';

export const buildProgressIcons = ({ Svg, Path, Circle, Rect, Ellipse, defaultColor }: IconPrimitives) => ({
  // ProgressIcons holds task/artifact status glyphs that communicate workflow state.
  NotStartedIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox={'0 0 24 24'} fill={'none'} {...props}>
      <Path d={'M3 12L12 3L21 12L12 21L3 12Z'} stroke={color} strokeLinejoin={'round'} />
    </Svg>
  ),
  InProgressIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox={'0 0 24 24'} fill={'none'} {...props}>
      <Path d={'M3 12L12 3L21 12L12 21L3 12Z'} stroke={color} strokeLinejoin={'round'} />
      <Path d={'M11 4V12V20L3 12L11 4Z'} fill={color} stroke={color} strokeLinejoin={'round'} />
    </Svg>
  ),
  ProgressIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox={'0 0 24 24'} fill={'none'} {...props}>
      <Path d={'M5 12C5 15.866 8.13401 19 12 19L12 5C8.13401 5 5 8.13401 5 12Z'} fill={color} />
      <Circle cx={'12'} cy={'12'} r={'7'} stroke={color} />
    </Svg>
  ),
  ReworkIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox={'0 0 24 24'} fill={'none'} {...props}>
      <Path d={'M3 12L12 3L21 12L12 21L3 12Z'} stroke={color} strokeLinejoin={'round'} />
    </Svg>
  ),
  PunchListIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' {...props}>
      <Circle cx='12' cy='12' r='4.75' stroke={color} strokeWidth='1.25' />
    </Svg>
  ),
  CompleteIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox={'0 0 24 24'} fill={'none'} {...props}>
      <Path d={'M3 12L12 3L21 12L12 21L3 12Z'} fill={color} />
    </Svg>
  ),
});
